import { useContext } from 'react'
import NotificationsContext from './context'
import { UseNotificationsManager } from './use-notifications-manager'

const useNotifications = (): UseNotificationsManager =>
  useContext(NotificationsContext)

export default useNotifications
